<div class="button-wrapper" *ngIf="isArchived">
    <div *ngIf="!edit && !hideExtraFields && personaSubsectionIdentifier && personaIdentifier" class="group">
        <apc-extra-fields-buttons [pertinence]="pertinence" [section]="section" [subsection]="subsection"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier"
            [formId]="personaSubsectionIdentifier">
        </apc-extra-fields-buttons>
    </div>
    <div class="last-group">
        <div class="last-group-permission-wrapper" *checkPermission="permissionEdit">
            <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" *ngIf="!edit">
                <button class="extra-button yellow" (click)="editForm(false, $event)">
                    <img class="edit" src="assets/ico/edit.svg" alt="edit" />
                </button>
            </div>
            <div *ngIf="subsection != 'company'">
                <div ngbTooltip="{{'buttons.clone' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" *ngIf="!edit">
                    <button class="extra-button orange" (click)="cloneForm()">
                        <img src="assets/ico/copy-regular.svg" alt="clone" />
                    </button>
                </div>
            </div>
            <!-- SPLIT -->
            <div *ngIf="subsection == 'company'">
                <div ngbTooltip="{{'buttons.split' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" *ngIf="!edit">
                    <button class="extra-button orange" (click)="splitCompany()">
                        <img src="assets/ico/split.svg" alt="split" />
                    </button>
                </div>
            </div>
            <!-- JOIN -->
            <div *ngIf="subsection == 'company' && indexRow != 0">
                <div ngbTooltip="{{'buttons.join' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" *ngIf="!edit">
                    <button class="extra-button orange" (click)="joinCompany()">
                        <img src="assets/ico/merge.svg" alt="join" />
                    </button>
                </div>
            </div>

            <span ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" *ngIf="!edit">
                <app-modal-info [title]="'Confirm action'" 
                                [text]="'Are you sure to delete this item?'" 
                                [color]="'red'"
                                [isQuestion]="false" 
                                [iconSrc]="'assets/ico/trash-alt-regular.svg'" 
                                (confirmEvent)="delete()">
                    <span action>
                        <button class="extra-button red" [class.disabled]="disableDelete">
                            <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
                        </button>
                    </span>
                </app-modal-info>
            </span>
        </div>
        <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button class="extra-button green" (click)="saveForm()">
                <img class="save" src="assets/ico/save.svg" alt="save" />
            </button>
        </div>
        <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button class="extra-button red" (click)="cancelForm()">
                <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
            </button>
        </div>
        <div *ngIf="edit && subsection == 'workinghours'">
            <button class="extra-button fulltime" (click)="fillFullTime()">
                <div class="button-icon icon fill-white" aria-label="clock" [inlineSVG]="'assets/ico/clock.svg'"></div>
                <div class="text">Full time</div>

            </button>
        </div>

    </div>
</div>